import React from "react";

export const LIMIT_ICONS = {
  audiences: (
    <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
  ),
  brands: (
    <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
    </svg>
  ),
  projects: (
    <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
    </svg>
  ),
  users: (
    <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  ),
  scripts: (
    <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  videos: (
    <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
    </svg>
  ),
  ideas: (
    <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
    </svg>
  ),
  api_requests: (
    <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" />
    </svg>
  ),
};

export function formatLimits(limits) {
  if (!limits) return [];
  const items = [];
  if (limits.brands > 0) items.push({ key: "brands", text: `${limits.brands} brand${limits.brands !== 1 ? "s" : ""}` });
  if (limits.audiences > 0) items.push({ key: "audiences", text: `${limits.audiences} audience${limits.audiences !== 1 ? "s" : ""}` });
  if (limits.ideas > 0) items.push({ key: "ideas", text: `${limits.ideas} idea${limits.ideas !== 1 ? "s" : ""}/mo` });
  if (limits.scripts > 0) items.push({ key: "scripts", text: `${limits.scripts} script${limits.scripts !== 1 ? "s" : ""}/mo` });
  if (limits.api_requests > 0) items.push({ key: "api_requests", text: `${limits.api_requests.toLocaleString()} API requests/30d` });
  return items;
}

export function formatPrice(price, cycle) {
  if (price == null || price === 0) return { main: "Free", unit: "" };
  if (cycle === "yearly" || cycle === "annual") return { main: `$${price}`, unit: "/yr" };
  return { main: `$${price}`, unit: "/mo" };
}

export function getPlanPriceDisplay(plan, billingCycle) {
  if (!plan?.price) return null;
  const isYearly = billingCycle === "yearly";
  const unit = isYearly ? "/yr" : "/mo";
  const price = isYearly ? plan.price.annual : plan.price.monthly;
  const discounted = isYearly ? plan.price.annual_discounted : plan.price.monthly_discounted;
  if (discounted != null) {
    return { discounted, original: price, unit, hasDiscount: true };
  }
  return { price, unit, hasDiscount: false };
}

export function buildPlanFeatures(planKey, planConfig) {
  const plan = planConfig?.[planKey];
  const items = [];
  if (plan?.prev_plan) {
    items.push({ type: "prefix", text: `Everything in ${plan.prev_plan}` });
  }
  (plan?.features || []).forEach((feature) => {
    if (feature.name) {
      items.push({ type: "feature", name: feature.name, description: feature.description });
    }
  });
  return items;
}

export function buildPlanLimits(planKey, planConfig) {
  return formatLimits(planConfig?.[planKey]?.limits);
}
